import moment from 'moment-mini'
import {
  catchError,
  concatMap,
  filter,
  map,
  mergeMap,
  take,
  tap,
  withLatestFrom
} from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType, OnInitEffects } from '@ngrx/effects'
import { createAction, Store } from '@ngrx/store'

import { ConfigurationOption } from './configuration-option'
import { configurationOptionActions } from './configuration-option.actions'
import * as fromConfigurationOptions from './configuration-option.reducer'
import { configurationOptionSelectors } from './configuration-option.selectors'
import { ConfigurationOptionService } from './configuration-option.service'
import { normalizeToSchema } from 'src/app/shared/normalization/normalization'
import { normalizationActions } from 'src/app/shared/normalization/normalization.actions'
import { of } from 'rxjs'
import { persistentUserRoleSelectors } from '../role/user-role/persistent-user-role/persistent-user-role.selector'
import { userRoleActions } from '../role/user-role/user-role.actions'
import { RequestQueryBuilder } from '@nestjsx/crud-request'
import { UserAccessRightService } from 'src/app/shared/services/user-access-rights.service'
import { AccessRights } from '../role/user-role/user-role'

@Injectable()
// implements OnInitEffects
export class ConfigurationOptionEffects extends ResourceEffects<ConfigurationOption> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public configurationOptionService: ConfigurationOptionService,
    public userAccessRightService: UserAccessRightService
  ) {
    super(
      fromConfigurationOptions.FEATURE_NAME,
      configurationOptionService,
      configurationOptionActions,
      actions$
    )
  }

  ngrxOnInitEffects() {
    return configurationOptionActions.initActions()
  }

  initActions = createEffect(() =>
    this.actions$.pipe(
      ofType(configurationOptionActions.initActions),
      // disable client side caching
      withLatestFrom(
        this.store.select(configurationOptionSelectors.selectState)
      ),
      filter(([action, configurationOptionState]) => {
        // due to bugs we now just allways fetch
        this.store
          .select(persistentUserRoleSelectors.selectSelectedUserRole)
          .pipe(take(1))
          .subscribe((pUr) => {
            if (
              pUr &&
              this.userAccessRightService.hasAccessRights(pUr?.accessRights, [
                AccessRights.UserRoles_read
              ])
            ) {
              this.store.dispatch(
                userRoleActions.fetchMany({
                  params: RequestQueryBuilder.create({
                    search: { userId: pUr.userId },
                    join: [{ field: 'role' }, { field: 'organization' }]
                  })
                })
              )
            }
          })
        console.log('Configuration options will fetch')
        return true
      }),
      mergeMap((x) => [
        configurationOptionActions.resetState(),
        configurationOptionActions.fetchMany({})
      ])
    )
  )

  updateOrCreateManyInBulk = createEffect(() =>
    this.actions$.pipe(
      ofType(configurationOptionActions.updateOrCreateManyInBulk),
      concatMap((action) =>
        this.configurationOptionService
          .updateOrCreateManyInBulk(action.form, action.noSite)
          .pipe(
            map((configurationOptions) =>
              normalizationActions.upsertMany({
                entities: normalizeToSchema({ configurationOptions })
              })
            )
          )
      ),
      catchError(() =>
        of(configurationOptionActions.setLoading({ isLoading: false }))
      )
    )
  )

  // updateOrCreateManyInBulk = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(configurationOptionActions.updateOrCreateManyInBulk),
  //     concatMap((action) =>
  //       this.configurationOptionService
  //         .updateOrCreateManyInBulk(action.form)
  //         .pipe(
  //           map((configOptions) =>
  //             normalizationActions.upsertMany({
  //               entities: normalizeToSchema({ configOptions })
  //             })
  //           ),
  //           catchError(
  //             () => of(null)
  //             // of(configurationOptionActions.setLoading({ isLoading: false }))
  //           )
  //         )
  //     )
  //   )
  // )
}
